import { useFormContext } from '@/lib/form-contexts'
import { cn } from '@/lib/utils'
import { Button, type ButtonProps } from '../ui/button'
import LoadingSpinner from '../ui/loading-spinner'
import { useIsReadOnly } from '@/lib/casl'

export type SubmitButtonProps = ButtonProps & {
  mutation?: { isPending?: boolean }
  disableWhenInvalid?: boolean
  keepChildrenWhileLoading?: boolean
}

export default function SubmitButton({
  children,
  mutation = {},
  className,
  disabled = false,
  disableWhenInvalid = true,
  keepChildrenWhileLoading = false,
  ...props
}: SubmitButtonProps) {
  const form = useFormContext()
  const { isReadOnly } = useIsReadOnly()
  return (
    <form.Subscribe
      selector={(state) => [state.canSubmit, state.isSubmitting, state.errors] as const}
    >
      {([canSubmit, isSubmitting, errors]) => {
        const isLoading = isSubmitting || mutation?.isPending

        return (
          <Button
            className={cn('w-full', className)}
            type="submit"
            disabled={
              disabled ||
              isLoading ||
              isReadOnly ||
              (disableWhenInvalid && (errors.length > 0 || !canSubmit))
            }
            {...props}
          >
            {isLoading ? (
              keepChildrenWhileLoading ? (
                <>
                  {children}
                  <LoadingSpinner className="size-4" />
                </>
              ) : (
                <LoadingSpinner />
              )
            ) : (
              children
            )}
          </Button>
        )
      }}
    </form.Subscribe>
  )
}
